module.exports = __webpack_public_path__ + "static/img/slide_2_fr.ad2e32b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_2_fr.svg
// module id = j4q5
// module chunks = 0